import React from "react";
import { useSelector } from "react-redux";
import Card from "../../../../shared/components/ui/card/Card";
import RoleHolderRow from "./roleHolderRow/RoleHolderRow";
import classes from "./RoleHoldersList.module.css";

const RoleHoldersList = ({ onRemove }) => {
    const { texts } = useSelector((state) => state.translate);
    const { schoolManagers } = useSelector((state) => state.schoolManager);


    return (
        <>{schoolManagers.filter(m => m.isManager).length > 0 &&
            <Card className={classes.Card}>
                <p className={classes.CardTitle}>{texts.additionalPermissions}</p>
                <div className={classes.Table}>
                    <div className={classes.TableHeader}>
                        <span className={classes.HeaderName}>{texts.name}</span>
                        <span className={classes.HeaderActions}>{texts.actions}</span>
                    </div>
                    <div className={classes.TableBody}>
                        {schoolManagers.filter(m => m.isManager).map((participant, index) => (
                            <RoleHolderRow
                                key={participant.id}
                                participant={participant}
                                onRemove={onRemove}
                                index={index}
                            />
                        ))}
                    </div>
                </div>
            </Card>}
        </>
    );
};

export default RoleHoldersList;
